import { Fabricator } from './Fabricator'

export abstract class ApiFabricator<T extends { id: string; attributes: object; relationships?: object }> extends Fabricator<T> {
  private static idsMap: { [key: string]: number } = {}

  public static getId(type: string) {
    if (!ApiFabricator.idsMap[type]) ApiFabricator.idsMap[type] = 0
    return `${ApiFabricator.idsMap[type]++}`
  }

  setId(value: string) {
    this.setters.push(base => ({ ...base, id: value }))
    return this
  }

  setAttr<K extends keyof T['attributes']>(key: K, value: T['attributes'][K]) {
    this.setters.push(base => ({ ...base, attributes: { ...base.attributes, [key]: value } }))
    return this
  }

  setAttrFn<K extends keyof T['attributes']>(key: K, setter: (value: T['attributes'][K]) => T['attributes'][K]) {
    this.setters.push(base => ({
      ...base,
      attributes: { ...base.attributes, [key]: setter((base.attributes as any)[key]) },
    }))
    return this
  }

  setRelationship<K extends keyof T['relationships']>(key: K, value: T['relationships'][K]) {
    this.setters.push(base => ({ ...base, relationships: { ...base.relationships, [key]: value } }))
    return this
  }
}
